import {IMultiOccurrenceOptions} from '../../../../../core/services/multi-occurrence.service';
import {IParametresRechercheService} from '../../../../../core/services/parametres-recherche.service';
import {IMenuClass} from '../../../../../core/services/menu/menu.service';
import {IRoute} from '../../../../../core/interfaces/route.interface';
import {IMenuItemForageClass} from '../../../../../core/services/menu/menu-item-forage.service';

interface IPageTf0001 {
    multiOccurrenceOptions: IMultiOccurrenceOptions;
}

/* @ngInject */
export default function Tf0001Controller(Menu: IMenuClass,
                                         parametresRecherche: IParametresRechercheService,
                                         tf2007Route: IRoute,
                                         MenuItemForage: IMenuItemForageClass) {
    const vm: IPageTf0001 = this;

    vm.multiOccurrenceOptions = {
        navigatePage: tf2007Route.NAME,
        navigateParams: (rowData:any) => (
            {
                id: rowData.folcleint,
                folcleint: rowData.folcleint
            }
        ),

        actionsNouveaux: new Menu([
            new MenuItemForage(tf2007Route.NAME)
        ]),
        fonctions: {
            rechercheCollapsable: false
        },
        colonnesVisibles: [
            {nom: 'folcod', largeur: 70},
            {nom: 'foldsc', largeur: 260},
            {nom: 'folann', largeur: 100},
            {nom: 'folnumappfml', largeur: 100},
            {nom: 'folnumappxml', largeur: 100},
            {nom: 'vaedscfedpro', largeur: 100},
            {nom: 'folimpori', largeur: 100},
            {nom: 'folimpmod', largeur: 100},
            {nom: 'folshexml', largeur: 100}
        ]
    };
}
